import * as React from 'react';
import formatters from '../formatters';
import {
  optimizationsCountAsPercentage,
  optimizationsRevenueAsPercentage,
} from './common';

export function optimizationsCasualCountAsPercentage(
  benchmark: number,
  value: number,
  score: number
): string | any {
  return optimizationsCountAsPercentage(benchmark, value, score);
}

export function optimizationsCasualRevenueAsPercentage(
  benchmark: number,
  value: number,
  score: number
): string | any {
  return optimizationsRevenueAsPercentage(benchmark, value, score);
}

export function optimizationsCasualMigrationForward(
  benchmark: number,
  value: number,
  score: number
): string | any {
  if (value > benchmark) {
    return [
      {
        text: `Segment Migration (C>L) Rate ${formatters.percent.format(
          value
        )}, ${formatters.count.format(
          (value - benchmark) * 100
        )} points above benchmark`,
        negative: false,
      },
    ];
  } else {
    return [
      {
        text: `Segment Migration (C>L) Rate ${formatters.percent.format(
          value
        )}, ${formatters.count.format(
          (benchmark - value) * 100
        )} points below benchmark`,
        negative: true,
      },
    ];
  }
}

export function optimizationsCasualCostToActivate(
  benchmark: number,
  value: number,
  score: number
): string | any {
  if (value > benchmark) {
    return [
      {
        text: `Cost to Activate ${formatters.percent.format(
          value
        )}, ${formatters.count.format(
          (value - 1) * 100
        )} points above benchmark`,
        negative: false,
      },
    ];
  } else {
    return [
      {
        text: `Cost to Activate ${formatters.percent.format(
          value
        )}, ${formatters.count.format(
          (1 - value) * 100
        )} points below benchmark`,
        negative: true,
      },
    ];
  }
}
